<template>
	<div class="chinese-medical-matter">
		<v-row no-gutters align="center" class="mb-5">
			<v-btn
				color="primary"
				fab
				x-small
				@click="searchFormula = !searchFormula"
				:disabled="!$store.getters.hasModule('mtc')"
			>
				<v-icon>add</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="primary" small class="ml-2" @click="showRecommendations = true" :disabled="!$store.getters.hasModule('mtc')">
				<translate>Recommendations</translate>
			</v-btn>
			<CMMRecommendations
				v-if="showRecommendations"
				v-model="showRecommendations"
				@add-recommendations="addRecommendations"
				type="formula"
			/>
		</v-row>
		<v-row v-if="searchFormula" no-gutters class="my-6 px-3">
			<v-col cols="12">
				<SearchProducts context="appointment" @add-product="addFormula" type="formula" :providersFilter="true" />
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12" md="12">
				<ProductList
					:products="formulas.products"
					context="appointment"
					type="formula"
					@remove-product="removeFormula"
					@edit-posology="editPosology"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ProductList from "@/components/products/ProductList.vue";
import SearchProducts from "@/components/products/SearchProducts.vue";
import CMMRecommendations from "@/components/appointment/treatments/tcm/CMMRecommendations.vue";
import axios from "axios";

export default {
	name: "ChineseMedicalMatter",
	props: ["formulas"],
	components: {
		ProductList,
		CMMRecommendations,
		SearchProducts
	},
	data: () => ({
		searchFormula: false,
		showRecommendations: false
	}),
	methods: {
		addRecommendations(formulas) {
			console.log(formulas);
			formulas.forEach(f => {
				if(f.classic) this.addFormula(f.id, f.ingredients);
				else this.addFormula(f.id);
			});
		},
		removeFormula(formula) {
			//CALL API
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/formula/" +
						formula.product.id +
						"/delete"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						//this.supplements = response.data.supplements;
						this.formulas.products.splice(
							this.formulas.products.indexOf(formula),
							1
						);
						//this.getSubstanceQuantity();
					}
				})
				.catch(error => console.log(error));
		},
		addFormula(formulaId, substanceQuantity = null, presentationId = null) {
			var exist = false;
			for (var i = 0; i < this.formulas.products.length; i++) {
				if (this.formulas.products[i].product.id == formulaId) {
					exist = true;
					break;
				}
			}
			if (!exist) {
				//CALL API
				console.log("ADD FORMULA");
				const appointmentId = this.$route.params.aid;
				const patientId = this.$route.params.aid;
				const formData = new FormData();
				if (substanceQuantity) {
					substanceQuantity.forEach(sq => {
						formData.append(sq.id, sq.quantity);
					});
				}
				if (presentationId) formData.append("product_presentation", presentationId);
				axios
					.post(
						"/patient/" +
							patientId +
							"/appointment/" +
							appointmentId +
							"/formula/" +
							formulaId +
							"/add",
						formData
					)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							this.formulas.products.push(response.data.product);
							//this.supplements.substance_quantity = response.data.substance_quantity;
							//his.getSubstanceQuantity();
						}
					})
					.catch(error => console.log(error));
			}
		},
		editPosology(formula, frequency) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			const formData = new FormData();
			formData.append("morning", frequency.morning);
			formData.append("middle_morning", frequency.middle_morning);
			formData.append("half_day", frequency.half_day);
			formData.append("middle_afternoon", frequency.middle_afternoon);
			formData.append("night", frequency.night);
			if (frequency.aditional_info != null) {
				formData.append("aditional_info", frequency.aditional_info);
			}
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/formula/" +
						formula.product.id +
						"/edit",
					formData
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "edited") {
							//this.formulas.substance_quantity = response.data.substance_quantity;
						}
					}
				})
				.catch(error => console.log(error));
		},
		getSubstanceQuantity() {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.get(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/formulas_substance_quantity"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						this.formulas.substance_quantity = response.data.substance_quantity;
					}
				})
				.catch(error => console.log(error));
		}
	},
	created() {
		this.$root.$on('tour-treatments-mmc', () => {
			this.searchFormula = true;
		});
		this.$root.$on('tour-treatments-mmc-add', () => {
			this.addFormula(284);
			this.searchFormula = false;
		});
	}
};
</script>

<style scoped>
.v-input__slot {
	min-height: 40px !important;
}
</style>